<style lang="scss" scoped="">
@import "../../../../assets/scss/mixins";

$leftWidth: 180px;
.min-gutter {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.content-part {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;

  .content-left {
    width: $leftWidth;
  }

  .content-right {
    > h3 {
      left: $leftWidth;
    }

    left: $leftWidth;
    padding: 65px 20px 0 20px;

    .show-content {
      padding: 0 20px;
      display: block;
    }
  }

  .min-gutter {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__label {
      font-size: 12px
    }
  }
}

.el-form .el-select {
  display: block;
}

.el-form .el-cascader {
  display: block;
}
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix">添加</h2>
        <ul>
          <li class="list-style" v-for="item in productListSet" @click="activeIndex = item.key"
              :class="{ 'active' : activeIndex===item.key}">
            <span>{{ item.name }}            <span
              v-show="form.businessOrgIdList.length && item.key === 1">({{
                form.businessOrgIdList.length
              }})</span></span>
          </li>
          <li class="text-center" style="margin-top:30px;position:absolute;bottom:50px;left:0;right:0;">
            <el-button type="primary" @click="onSubmit('form')" native-type="submit" :disabled="doing">保存</el-button>
          </li>
        </ul>
      </div>
      <div class="content-right min-gutter">
        <h3 class="clearfix">添加往来单位</h3>
        <el-form ref="form" :model="form" label-width="100px"
                 @submit.prevent="onSubmit()" onsubmit="return false" v-loading="loading">
          <div v-show="activeIndex === 0">
            <el-row>
              <el-col :span="12">
                <oms-form-row :span="8" label="单位分类">
                  <el-select :clearable="true" filterable multiple class="no-error-input"
                             popperClass="custom-select" remote v-model="filters.orgRelationTypeList">
                    <el-option :key="item.key" :label="item.label" :value="item.key"
                               v-for="item in orgRelationTypeList">
                    </el-option>
                  </el-select>
                </oms-form-row>
              </el-col>
              <el-col :span="12">
                <oms-form-row :span="8" label="所在地区">
                  <el-cascader :options="options" clearable v-model="filters.selectOptions"
                               placeholder="请选择省市区" @change="filterObjectOrgList" class="no-error-input"
                               :change-on-select="true" style="display: block"></el-cascader>
                </oms-form-row>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <oms-form-row :span="8" label="单位名称">
                  <el-input v-model="filters.keyWord" class="no-error-input" placeholder="请输入单位名称"></el-input>
                </oms-form-row>
              </el-col>
              <el-col :span="8">
                <oms-form-row :span="2" label="">
                  <el-button @click="searchInOrder" native-type="submit" plain type="primary">查询</el-button>
                  <el-button @click="resetSearchForm">重置</el-button>
                </oms-form-row>
              </el-col>
            </el-row>
          </div>
          <el-form-item prop="businessOrgIdList" label="" label-position="top" label-width="0"
                        :rules="[{required: true, type: 'array', message: '请选择往来单位', trigger: 'change'}]">
            <org-table-paging-select no-select-title="未选往来单位" select-title="已选往来单位"
                                     maxHeight="100000" :showNoSelect="activeIndex === 0"
                                     :showSelect="activeIndex === 1"
                                     ref="pagingSelect" primaryKey="id" :filters="filters" @change="pagingSelectChange"
                                     :http-request="httpRequest" :column-list="columnList"/>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
import {BaseInfo, businessOrg} from '@/resources';
import MethodMixin from '@/mixins/methodsMixin';
import orgTablePagingSelect from './org-table-paging-select.vue';
import utils from '@/tools/utils';

export default {
  name: 'editForm',
  mixins: [MethodMixin],
  components: {orgTablePagingSelect},
  props: {
    showRight: Boolean
  },
  data: function () {
    let orgRelationTypeList = this.$store.state.orgRelationType;
    return {
      form: {
        orgId: this.$store.state.user.userCompanyAddress,
        businessOrgIdList: [],
        businessOrgList: []
      },
      options: utils.address,
      columnList: [
        {
          label: '单位名称',
          prop: 'name',
          width: 240
        },
        {
          label: '单位分类',
          prop: 'orgRelationTypeList',
          width: 150,
          format(val) {
            if (!val) return '';
            return val.map(m => {
              let item = orgRelationTypeList.find(f => f.key === m);
              return item && item.label || m;
            }).join(',');
          }
        },
        {
          label: '系统代码',
          prop: 'manufacturerCode',
          width: 200
        }
      ],
      filters: {
        orgRelationTypeList: [],
        selectOptions: [],
        keyWord: '',
        province: '',
        city: '',
        region: '',
        auditedStatus: 1,
        state: 0
      },
      productListSet: [
        {key: 0, name: '未选单位'},
        {key: 1, name: '已选单位'}
      ],
      activeIndex: 0,
      doing: false,
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    orgRelationTypeList() {
      return this.$store.state.orgRelationType;
    }
  },
  watch: {
    showRight: function () {
      this.resetForm();
      this.$refs.pagingSelect.selectList = [];
      this.$refs.pagingSelect.data = [];
      this.queryUpAllFactory();
      this.form = {
        orgId: this.$store.state.user.userCompanyAddress,
        businessOrgIdList: []
      };
      this.$nextTick(() => {
        this.$refs['form'] && this.$refs['form'].clearValidate();
      });
    }
  },
  methods: {
    httpRequest: BaseInfo.queryPager,
    pagingSelectChange(val) {
      if (val) {
        this.form.businessOrgIdList = val.map(m => m.id);
        this.form.businessOrgList = [];
        val.forEach(m => this.form.businessOrgList.push({
          "businessOrgId": m.id,
          "businessOrgCode": m.manufacturerCode,
          "businessOrgName": m.name
        }));
      } else {
        this.form.businessOrgIdList = [];
        this.form.businessOrgList = [];
      }
      this.$refs.form.validateField('businessOrgIdList');
    },
    filterObjectOrgList(val) {
      let ary = utils.formatAddressByType(val[0], val[1], val[2], 'label');
      this.filters.province = ary[0];
      this.filters.city = ary[1];
      this.filters.region = ary[2];
    },
    searchInOrder() {
      this.$refs.pagingSelect.queryList(1);
    },
    resetForm() {
      this.filters = {
        orgRelationTypeList: [],
        selectOptions: [],
        keyWord: '',
        province: '',
        city: '',
        region: ''
      };
    },
    resetSearchForm() {
      this.resetForm();
      this.$nextTick(() => {
        this.$refs.pagingSelect.queryList(1);
      })
    },
    onSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        // 校验所选单位必填字段
        let vaild = this.form.businessOrgList.some(v => v.businessOrgName==='' || v.businessOrgCode==='');
        if (vaild) {
          this.$notify.warning({
            duration: 2000,
            name: '',
            message: '往来单位名称或往来单位编码不能为空。'
          });
          return;
        }
        this.doing = true;
        this.form.orgId = this.$store.state.user.userCompanyAddress;
        businessOrg.save(this.form).then(() => {
          this.doing = false;
          this.$notify.success({
            duration: 2000,
            name: '成功',
            message: '新增往来单位成功'
          });
          this.$emit('change', this.form);
          this.$emit('right-close', this.form);
        }).catch(error => {
          this.$notify.error({
            duration: 2000,
            message: error.response.data && error.response.data.msg || '新增往来单位失败'
          });
          this.doing = false;
        });
      });
    },
    doClose: function () {
      this.$emit('close');
      this.$refs['form'].resetFields();
    }
  }
};
</script>
